export default class TicketType {
    constructor(short_description_phrase = '',
                long_description_phrase = '',
                price = '',
                earliest_start_date = new Date().toISOString().substr(0, 10),
                latest_end_date = new Date().toISOString().substr(0, 10),
    )
    {
        this.short_description_phrase = short_description_phrase;
        this.long_description_phrase = long_description_phrase;
        this.price = price;
        this.earliest_start_date = earliest_start_date;
        this.latest_end_date = latest_end_date;
    }
}